import { Box, Stack } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

export type PageNumberBadgeProps = {
  pageNumber: number;
};

export const PageNumberBadge = ({ pageNumber }: PageNumberBadgeProps) => (
  <Stack alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
    <Box
      sx={theme => ({
        px: 1.5,
        py: 0.25,
        borderRadius: borderRadius('xl'),
        bgcolor: 'action.selected',
        typography: 'caption',
        color: theme.palette.text.secondary,
      })}
    >
      {pageNumber}
    </Box>
  </Stack>
);
